import axios  from "../../services/axios";
import { constants } from '../../constants';
export const listVans = async ({ filters, page, perPage }) => {
  try {
    const response = await axios.get(`/van/list`, {
      params: {
        name: filters?.name || '',
        username: filters?.username || '',
        page,
        perPage,
      },
  
    });
  
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch vans. Please try again later.';
    throw new Error(message);
  }
  };


export const deleteVan = async ({ id }) => {
  try {
    const response = await axios.delete(`/van/${id}`);
   return response;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete the van. Please try again.';
    throw new Error(message);
  }
};

export const addVan = async ({ name, username, password, id }) => {
  try {
    const response = await axios.post('/van/add', {
      name,
      username,
      password,
      id,
    });
  return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to add or update van. Please try again.';
    throw new Error(message);
  }
};

// FETCH SINGLE VAN
export const fetchVan = async ({ queryKey }) => {
  try {
  const [_key, id] = queryKey;
  const response = await axios.get(`/van/${id}`);
  return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch van details. Please try again.';
    throw new Error(message);
  }
};

